interface ModalProps {
  tall?: boolean
  children: React.ReactNode
}

const ModalStripe: React.FunctionComponent<ModalProps> = ({
  tall,
  children
}) => {
  return (
    <div className='bg-black flex justify-center items-start'>
      <div className='glow-effect'>
        <div className='diamond-corner p-[2px] sm:p-[4px] bg-dopage-lightGreen min-h-[300px] sm:min-h-[400px] w-full max-w-[670px]'>
          {/* Remove the fixed height and let it grow naturally */}
          <div className={`inner bg-black ${tall === true ? 'min-h-[600px] sm:min-h-[750px]' : 'min-h-[480px] sm:min-h-[580px]'}`} data-testid='modal-stripe-inner'>
            <div className='p-4 sm:p-[22px] flex flex-col items-center text-dopage-lightGreen h-full'>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalStripe
